import { render, staticRenderFns } from "./RibbonMenu.vue?vue&type=template&id=094ec98d&scoped=true"
import script from "./RibbonMenu.vue?vue&type=script&lang=js"
export * from "./RibbonMenu.vue?vue&type=script&lang=js"
import style0 from "./RibbonMenu.vue?vue&type=style&index=0&id=094ec98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ec98d",
  null
  
)

export default component.exports